module.exports = __webpack_public_path__ + "img/2.dd84e024.png";